module.exports = __webpack_public_path__ + "img/H-63-ER-450-BB.227a1807.png";